import React, { useMemo } from 'react';
import { Alert } from 'reactstrap';
import XTable from '../../components/Table/Table';

const ProviderSalesTab = ({ data, loading }) => {
  const columns = useMemo(
    () => [
      { Header: 'Proveedor', accessor: 'provider' },
      { Header: 'Ventas', accessor: 'count' },
      { Header: 'Precio Total', accessor: 'totalPrice' },
      { Header: 'Valor Neto', accessor: 'totalValorNeto' },
      { Header: 'Comisión Cliente', accessor: 'totalComisionCliente' },
      { Header: 'Comisión Proveedor', accessor: 'totalComisionProveedor' },
      { Header: 'IVA', accessor: 'totalIva' },
    ],
    [],
  );

  const tableData = useMemo(() => data || [], [data]);

  if (!loading && (!data || data.length === 0)) {
    return <Alert color="info">No hay datos de ventas por proveedor.</Alert>;
  }

  return <XTable columns={columns} data={tableData} loading={loading} />;
};

export default ProviderSalesTab;
